import { useEffect } from 'react';

const API_BASE = import.meta.env.VITE_API_URL || 'https://cardealeros-api.bowling-anthony.workers.dev';

function getSessionId(): string {
  let sid = sessionStorage.getItem('acp_sid');
  if (!sid) {
    sid = Math.random().toString(36).substring(2) + Date.now().toString(36);
    sessionStorage.setItem('acp_sid', sid);
  }
  return sid;
}

export function usePageTracker(path?: string) {
  useEffect(() => {
    const pagePath = path || window.location.pathname;

    const payload = {
      path: pagePath,
      referrer: document.referrer || '',
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      language: navigator.language,
      sessionId: getSessionId(),
      pageUrl: window.location.href,
    };

    // Use sendBeacon for reliability, fall back to fetch
    const url = `${API_BASE}/v1/tracker/hit`;
    const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });

    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, blob);
    } else {
      fetch(url, { method: 'POST', body: blob, keepalive: true }).catch(() => {});
    }
  }, [path]);
}
